export const PaymentAccountType = Object.freeze({
	CreditCard: 1,
	ACH: 2,
});
